/* Enum used for accessing arrays */
export var typeFormat;
(function (typeFormat) {
    typeFormat[typeFormat["HH"] = 0] = "HH";
    typeFormat[typeFormat["HHMM"] = 1] = "HHMM";
    typeFormat[typeFormat["HHMMSS"] = 2] = "HHMMSS";
    typeFormat[typeFormat["ALL"] = 3] = "ALL";
})(typeFormat || (typeFormat = {}));
;
/* Simple class to keep track of internal value and provide convenience functions */
export class Clock {
    /*private posInterval: [number, number, number];
    private posValid: [number[],number[],number[]];*/
    constructor(iVal, iMode, iMin, iMax, iStep) {
        /*let parts = iVal.replace(/-/g, '0').split(':');*/
        this.internalSeconds = iVal;
        this.min = iMin;
        this.max = iMax;
        this.step = iStep;
        /*this.internalSeconds = this.stringToSec(iVal);
        this.min = this.stringToSec(iMin);
        this.max = this.stringToSec(iMax);*/
        this.mode = iMode;
        /*parts = iInterval.split(':');*/
        /*this.posInterval = [(parseInt(parts[typeFormat.HH]) * 3600), (parseInt(parts[typeFormat.HHMM]) * 60), parseInt(parts[typeFormat.HHMMSS])];
        this.posValid = this.setPosValid(this.posInterval, parseInt(iMin.split(':')[typeFormat.HH]), parseInt(iMax.split(':')[typeFormat.HH]));*/
    }
    stringToSec(iStr) {
        let parts = iStr.split(':');
        return (!isNaN(Number(parts[typeFormat.HH])) ? (Number(parts[typeFormat.HH]) * 3600) : 0) +
            (!isNaN(Number(parts[typeFormat.HHMM])) ? (Number(parts[typeFormat.HHMM]) * 60) : 0) +
            (!isNaN(Number(parts[typeFormat.HHMMSS])) ? Number(parts[typeFormat.HHMMSS]) : 0);
    }
    /* set valid positions used for fast validation based on min max and interval */
    setPosValid(iArr, minH, maxH) {
        let res = [[], [], []];
        for (let i = 0; i < iArr.length; i++) {
            let max = (i == typeFormat.HH ? 24 : 60);
            let comp;
            if (i == typeFormat.HH)
                comp = Math.floor(iArr[i] / 3600);
            else if (i == typeFormat.HHMM)
                comp = Math.floor(iArr[i] / 60);
            else
                comp = iArr[i];
            let tmpArr = [];
            for (let j = 0; j < max; j++) {
                if (i == typeFormat.HH && (j < minH || j > maxH)) {
                }
                else if (j % comp == 0) {
                    tmpArr.push(j);
                }
            }
            res[i] = tmpArr;
        }
        return res;
    }
    increment(pos, bubble = true) {
        /*this.internalSeconds += this.posInterval[pos];
        if(pos != typeFormat.HH){
            if(!this.forceValid(false)){
                if(bubble) this.increment(pos-1, false);
            }
        }
        this.forceValid();
        return this.toString();*/
        if (this.step === 1 && pos !== typeFormat.HHMMSS) {
            if (pos == typeFormat.HH) {
                this.internalSeconds += 3600;
            }
            else if (pos == typeFormat.HHMM) {
                this.internalSeconds += 60;
            }
        }
        else {
            this.internalSeconds += this.step;
        }
        if (pos != typeFormat.HH) {
            if (!this.forceValid(false)) {
                if (bubble)
                    this.increment(pos - 1, false);
            }
        }
        this.forceValid();
        return this.toString();
    }
    decrement(pos, bubble = true) {
        /*this.internalSeconds -= this.posInterval[pos];
        if(pos != typeFormat.HH){
            if(!this.forceValid(false)){
                if(bubble) this.decrement(pos-1, false);
            }
        }
        this.forceValid();
        return this.toString();*/
        if (this.step === 1 && pos !== typeFormat.HHMMSS) {
            if (pos == typeFormat.HH) {
                this.internalSeconds -= 3600;
            }
            else if (pos == typeFormat.HHMM) {
                this.internalSeconds -= 60;
            }
        }
        else {
            this.internalSeconds -= this.step;
        }
        if (pos != typeFormat.HH) {
            if (!this.forceValid(false)) {
                if (bubble)
                    this.decrement(pos - 1, false);
            }
        }
        this.forceValid();
        return this.toString();
    }
    clearSecond() {
        let minutes, hours = Math.floor(this.internalSeconds / 3600);
        minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
        this.internalSeconds = (minutes * 60) + (hours * 3600);
        this.forceValid();
    }
    clearMinute() {
        let seconds, minutes, hours = Math.floor(this.internalSeconds / 3600);
        minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
        seconds = this.internalSeconds - (hours * 3600) - (minutes * 60);
        this.internalSeconds = seconds + (hours * 3600);
        this.forceValid();
    }
    clearHour() {
        let seconds, minutes, hours = Math.floor(this.internalSeconds / 3600);
        minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
        seconds = this.internalSeconds - (hours * 3600) - (minutes * 60);
        this.internalSeconds = seconds + (minutes * 60);
        this.forceValid();
    }
    setSecond(iSec, force = true) {
        let minutes, hours = Math.floor(this.internalSeconds / 3600);
        minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
        this.internalSeconds = iSec + (minutes * 60) + (hours * 3600);
        if (force)
            this.forceValid();
    }
    setMinute(iMin, force = true) {
        let seconds, minutes, hours = Math.floor(this.internalSeconds / 3600);
        minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
        seconds = this.internalSeconds - (hours * 3600) - (minutes * 60);
        this.internalSeconds = seconds + (iMin * 60) + (hours * 3600);
        if (force)
            this.forceValid();
    }
    setHour(iHour, force = true) {
        let seconds, minutes, hours = Math.floor(this.internalSeconds / 3600);
        minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
        seconds = this.internalSeconds - (hours * 3600) - (minutes * 60);
        this.internalSeconds = seconds + (minutes * 60) + (iHour * 3600);
        if (force)
            this.forceValid();
    }
    /* Handle numeric inputs */
    inputDigit(iDig, iPos, iPrevPos) {
        const currentTime = Date.now();
        let tmpVal, seconds, minutes, hours = Math.floor(this.internalSeconds / 3600);
        minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
        seconds = this.internalSeconds - (hours * 3600) - (minutes * 60);
        if (this.lastInputTime && (currentTime - this.lastInputTime) > 2000) {
            // If more than 2 seconds have passed, reset the current position value
            if (iPos === typeFormat.HH) {
                hours = 0;
            }
            else if (iPos === typeFormat.HHMM) {
                minutes = 0;
            }
            else if (iPos === typeFormat.HHMMSS) {
                seconds = 0;
            }
        }
        this.lastInputTime = currentTime;
        switch (iPos) {
            /* hours */
            case typeFormat.HH: {
                /* if inputting second digit */
                if (iPos == iPrevPos) {
                    /* append value */
                    tmpVal = parseInt(hours + '' + iDig);
                    /* if valid result, insert, else clear and insert digit */
                    if (tmpVal >= this.max) {
                        // this.setHour(iDig);
                        // return true;
                        return true;
                    }
                    else {
                        this.setHour(tmpVal);
                        return true;
                    }
                }
                else {
                    /* first digit - overrides saved value */
                    this.setHour(iDig, false);
                    return (iDig > 9);
                }
            }
            /* minutes */
            case typeFormat.HHMM: {
                if (iPos == iPrevPos) {
                    tmpVal = parseInt(minutes + '' + iDig);
                    if (tmpVal > 59) {
                        this.setMinute(iDig);
                        return true;
                    }
                    else {
                        this.setMinute(tmpVal);
                        return true;
                    }
                }
                else {
                    this.setMinute(iDig, false);
                    return (iDig >= 6);
                }
            }
            /* seconds */
            case typeFormat.HHMMSS: {
                if (iPos == iPrevPos) {
                    tmpVal = parseInt(seconds + '' + iDig);
                    if (tmpVal > 60) {
                        this.setSecond(iDig);
                        return true;
                    }
                    else {
                        this.setSecond(tmpVal);
                        return true;
                    }
                }
                else {
                    this.setSecond(iDig, false);
                    return false;
                }
            }
        }
    }
    getHour() {
        return (Math.floor(this.internalSeconds / 3600) + '').padStart(2, '0');
    }
    getMinute() {
        return (Math.floor((this.internalSeconds - (Math.floor(this.internalSeconds / 3600) * 3600)) / 60) + '').padStart(2, '0');
    }
    getSecond() {
        let seconds, minutes, hours = Math.floor(this.internalSeconds / 3600);
        minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
        seconds = this.internalSeconds - (hours * 3600) - (minutes * 60);
        return (seconds + '').padStart(2, '0');
    }
    getPosValid() {
        let secArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59], minArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59], hourArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
        let stepHour = Math.floor(this.step / 3600), stepMin = Math.floor((this.step - (stepHour * 3600)) / 60), stepSec = this.step - (stepHour * 3600) - (stepMin * 60);
        if (stepMin == 0)
            stepMin = 1;
        if (stepHour == 0)
            stepHour = 1;
        let minHour = Math.floor(this.min / 3600), maxHour = Math.floor(this.max / 3600);
        secArr = secArr.filter((value) => { return value % stepSec == 0; });
        minArr = minArr.filter((value) => { return value % stepMin == 0; });
        hourArr = hourArr.filter((value) => { return value % stepHour == 0 && (value >= minHour && value <= maxHour); });
        /*console.log(hourArr)*/
        return [hourArr, minArr, secArr];
        /*let res:[number[], number[], number[]] = [[], [], []];
        for(let i = this.min; i < this.max; i+=this.step){
            let h, m, s
            h = Math.floor(i / 3600);
            m = Math.floor((i - (h * 3600)) / 60)
            s = i - (h * 3600) - (m * 60)
            res[0].push(h);
            res[1].push(m);
            res[2].push(s);
        }
        function onlyUnique(value: number, index: number, self: Array<number>) {
            return self.indexOf(value) === index;
          }
        res[0] = res[0].filter(onlyUnique);
        res[1] = res[1].filter(onlyUnique);
        res[2] = res[2].filter(onlyUnique);
        return res;*/
    }
    reset() {
        let now = new Date(Date.now());
        this.internalSeconds = (now.getHours() * 3600) + (now.getMinutes() * 60) + now.getSeconds();
        this.forceValid();
    }
    forceValid(force = true) {
        let tmpInternal;
        if (!(this.internalSeconds >= this.min)) {
            tmpInternal = this.min;
        }
        else {
            if (!(this.internalSeconds <= this.max)) {
                tmpInternal = this.max;
            }
            else {
                // Check for a valid interval
                if (this.step === 1) {
                    return true;
                }
                const diff = this.internalSeconds % this.step;
                if (diff === 0) {
                    return true;
                }
                else {
                    if (this.step - diff > diff) {
                        tmpInternal = this.internalSeconds - diff;
                    }
                    else {
                        tmpInternal = this.internalSeconds + (this.step - diff);
                    }
                }
            }
        }
        if (this.internalSeconds !== tmpInternal) {
            if (force) {
                if (tmpInternal === Infinity || tmpInternal === -Infinity || isNaN(tmpInternal))
                    tmpInternal = 0;
                this.internalSeconds = tmpInternal;
            }
            return false;
        }
        return true;
        /*let tmpInternal;
        if(!(this.internalSeconds >= this.min)){
            tmpInternal = this.min;
        } else if(!(this.internalSeconds <= this.max)){
            tmpInternal = this.max;
        } else {
            // check for valid interval
            if(this.posInterval[typeFormat.HH] == 3600 && this.posInterval[typeFormat.HHMM] == 60 && this.posInterval[typeFormat.HHMMSS] == 1){
                // all values are valid
                return true;
            }
            let hours = Math.floor(this.internalSeconds / 3600);
            let minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
            let seconds = this.internalSeconds - (hours * 3600) - (minutes * 60);
            if(this.mode == typeFormat.HH){
                if(hours % this.posInterval[typeFormat.HH] == 0){
                    //valid
                    return true;
                }
            }
            tmpInternal = (closest(this.posValid[typeFormat.HH], hours) * 3600) + (closest(this.posValid[typeFormat.HHMM], minutes) * 60) + (closest(this.posValid[typeFormat.HHMMSS], seconds));
        }
        if(this.internalSeconds !== tmpInternal){
            if(force) this.internalSeconds = tmpInternal;
            return false
        }
        return true;
        // internal helper to find closest valid value
        function closest(iArr: number[], iTarget:number) {
            let minDiff = 61;
            let ans = -1;
            for(let i = 0; i < iArr.length; i++) {
                let m = Math.abs(iTarget - iArr[i]);
                if (m < minDiff) {
                    minDiff = m;
                    ans = iArr[i];
                }
            }
            return ans;
        }*/
        return true;
    }
    /* format result according to PICTime format */
    toString() {
        let res;
        let seconds, minutes, hours = Math.floor(this.internalSeconds / 3600);
        if (this.mode == typeFormat.HH) {
            res = String(hours).padStart(2, '0');
        }
        else if (this.mode == typeFormat.HHMM) {
            minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
            res = String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
        }
        else {
            minutes = Math.floor((this.internalSeconds - (hours * 3600)) / 60);
            seconds = this.internalSeconds - (hours * 3600) - (minutes * 60);
            res = String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
        }
        return res;
    }
    getSec() {
        return this.internalSeconds + '';
    }
    /* Return the current clock seconds */
    getValue() {
        return this.internalSeconds;
    }
}
//# sourceMappingURL=Clock.js.map